<template>
  <section id="services" class="services-section">
    <h2>Our Services</h2>
    <div class="grid-container">
      <div class="grid-item">
        <h3>Psoriasis Treatment</h3>
        <ul>
          <li>Biological Therapy</li>
          <li>Phototherapy</li>
          <li>Systemic Treatment</li>
          <li>Topical Treatment</li>
        </ul>
      </div>
      <div class="grid-item">
        <h3>Specialized Care</h3>
        <ul>
          <li>Personalized Treatment Plans</li>
          <li>Regular Monitoring</li>
          <li>Lifestyle Counseling</li>
          <li>Dietary Advice</li>
        </ul>
      </div>
      <div class="grid-item">
        <h3>Additional Services</h3>
        <ul>
          <li>Clinical Trials</li>
          <li>Research Participation</li>
          <li>Second Opinions</li>
          <li>Telemedicine</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection'
}
</script>

<style scoped>
.services-section {
  padding: 60px 20px;
  background-color: #f8f9fa;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.grid-item {
  background-color: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.grid-item:hover {
  transform: translateY(-5px);
}

.grid-item h3 {
  color: #2c3e50;
  margin-bottom: 20px;
  text-align: center;
}

.grid-item ul {
  list-style-type: none;
  padding: 0;
}

.grid-item li {
  margin: 12px 0;
  padding-left: 25px;
  position: relative;
}

.grid-item li:before {
  content: "✓";
  color: #42b983;
  position: absolute;
  left: 0;
}
</style>
